import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'

import { useDispatchOpenChat } from '@hooks/useDispatchOpenChat'

interface Props {
  title?: string
  description?: string | React.FC
}

export const SupportModal: BaseModalType<Props> = (props) => {
  const { dispatchOpenChat, isLoading: isHubSpotChatLoading } = useDispatchOpenChat()
  const { t } = useTranslation()
  const { title, close } = props
  const { description: Description } = props

  const text = !Description ? null : typeof Description === 'string' ? Description : <Description />

  const handleContactSupport = () => {
    dispatchOpenChat()
    close()
  }

  return (
    <Modal>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body isLoading={isHubSpotChatLoading}>
        <Modal.Body.Text>{text}</Modal.Body.Text>
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close} textOverflow='wrap'>
          {t('Got It')}
        </Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={handleContactSupport} textOverflow='wrap'>
          {t('Contact Support')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
